import React from 'react'
import PropTypes from 'prop-types';
import _ from 'lodash'

const leadTimeDays = (d) => {
  return `${_.replace(d, /US|MK/, '')} ${d === 1 ? 'day' : 'days'}`;
}

const PriceMatrixHeadLeadTimes = ({ usLeadTimes }) => {
  if (!usLeadTimes) return null;

  return (
    <tr>
      <th className="qty">Qty</th>
      {usLeadTimes.map((lt) => <th key={lt}>{leadTimeDays(lt)}</th>)}
    </tr>
  )
};

const PriceMatrixHead = ({ usCombined }) => {
  const usLeadTimes = usCombined.lead_times;
  return (
    <thead>
      <PriceMatrixHeadLeadTimes usLeadTimes={usLeadTimes} />
    </thead>
  );
};

// PriceMatrixHead.defaultProps = {
//   leadTimes: [],
// };

PriceMatrixHead.propTypes = {
  usCombined: PropTypes.shape({
    lead_times: PropTypes.array.isRequired,
  }).isRequired,
}

export default PriceMatrixHead;
